import { AddOutlined, AdjustOutlined, ArrowDropDown, ArrowDropDownCircleOutlined, CloseFullscreenOutlined, DirectionsRunOutlined, ExpandCircleDownOutlined, HighlightOffOutlined, MinimizeOutlined, RefreshOutlined, RemoveCircleOutlined, RemoveCircleOutlineOutlined, UnfoldLessDoubleOutlined, UnfoldLessOutlined, UnfoldLessRounded, UnfoldLessSharp, ZoomInMapOutlined } from "@mui/icons-material";
import { Button, Fab, Paper, TextField, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import WazzapNotifyButton from "./WazzappNotifyButton";
import DiagonalCollapseIcon from "./Icons/DiagonalCollapseIcon";

interface Props {
    onAdd: (text: string) => void;
    onMinimize: (minimize: boolean) => void;
    defaultExpanded: boolean;
    betweenFriends: boolean;
}

export default function AddNewItemCard({ onAdd, onMinimize, defaultExpanded, betweenFriends }: Props) {

    const [newText, setNewText] = useState("");
    const [minimize, setMinimize] = useState(!defaultExpanded);
    const inputRef = useRef<HTMLInputElement>(null)
    const DOUBLE_TAP_DELAY = 300; // ms
    const tapCountRef = useRef(0);
    const tapTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const handleTap = () => {
        tapCountRef.current++;

        if (tapCountRef.current === 1) {
            // Start timer for first tap
            tapTimeoutRef.current = setTimeout(() => {
                tapCountRef.current = 0; // Reset if no second tap
            }, DOUBLE_TAP_DELAY);
        } else if (tapCountRef.current === 2) {
            // Double tap detected
            clearTimeout(tapTimeoutRef.current!);
            tapCountRef.current = 0;
            setMinimize(!minimize);
        }
    };

    useEffect(() => {
        onMinimize(minimize);
    }, [minimize]);


    return (
        <>
            <Paper
                onClick={() => setMinimize(!minimize)}
                onTouchEnd={handleTap}
                sx={{
                    p: minimize ? 1 : 4,
                    width: '100%',
                    maxWidth: 400,
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 10,
                    gap: 2,
                }}
                elevation={3}
            >
                {minimize && (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 20,
                        position: 'relative'
                    }}>
                        <span style={{ display: 'flex', flexDirection: 'row', marginRight: 11, color: '#7e7777' }}>
                            <AddOutlined />
                            <Typography >Lägg till ny</Typography>
                        </span>
                        {/* <Typography
                            style={{
                                position: 'absolute',
                                right: 0,
                                // color: '#c2bcc2',
                                // transform: 'rotate(180deg)',
                                marginRight: 6,

                            }}
                        >
                            👆
                        
                        </Typography> */}
                        <ArrowDropDown
                            style={{
                                position: 'absolute',
                                right: 0,
                                color: '#c2bcc2',
                                transform: 'rotate(180deg)',
                                marginRight: 6,

                            }}
                        /> 
                    </div>

                )}


                {!minimize && (
                    <>
                        <ArrowDropDown style={{ margin: -20, alignSelf: 'flex-end', paddingRight: 6, paddingTop: 4, color: '#c2bcc2' }} />
                        {/* <Typography style={{ margin: -20, alignSelf: 'flex-end', marginRight:-15, paddingTop: 1, color: '#c2bcc2', transform: 'rotate(180deg)' }}>👆</Typography> */}
                        {/*,transform: 'rotate(45deg)'*/}
                        {/* <DiagonalCollapseIcon color='#d0d8d3' style={{margin:-24, alignSelf:'flex-end', paddingRight:2,paddingTop:0, }} /> */}
                        <Typography
                            variant="h5"
                            align="center"
                            style={{ margin: -2 }}
                            sx={{ fontSize: "1.45rem" }} // smaller than default h5
                        >
                            {betweenFriends ? "Ey" : "Älskling"}! Vad handla?!?
                        </Typography>
                        <TextField
                            inputRef={inputRef}
                            value={newText}
                            size="small"
                            type='text'
                            placeholder="Typ mjölk ..."
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) => setNewText(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault()
                                    if (newText.trim() !== '') {
                                        onAdd(newText)
                                        setNewText('')
                                        inputRef.current?.blur()
                                    }
                                }
                            }}
                            fullWidth
                        />
                        <Button
                            startIcon={<AddOutlined />}
                            className="btn"
                            variant="contained"
                            style={{
                                backgroundColor: '#33a064',
                                borderRadius: 10,
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (newText.trim() !== '') {
                                    onAdd(newText)
                                    setNewText('')
                                    inputRef.current?.blur()
                                }
                            }}
                            disabled={false}
                        >
                            Lägg till
                        </Button>
                    </>
                )}

            </Paper>
        </>
    );
}
